
/*
 * action types
 */

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const TOGGLE_READ = 'TOGGLE_READ';

/*
 * action creators
 */
export function addNotification(type, status, message) {
    return { type: ADD_NOTIFICATION, messageType: type, status, message }
}

export function toggleRead(index) {
    return { type: TOGGLE_READ, index }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/notificationsActions.js
 **/